type GetAdminPathFunction = (path: string) => string;

const getAdminsPath: GetAdminPathFunction = (path: string) => `/admins${path}`;

export default getAdminsPath;
